'use strict';

const $stickyBar = $('.cc-stickyBar');
const $header = $('.js-header');

$(() => {
    let lastScroll = 0;

    function scrollToActiveItem() {
        const $activeItem = $('.cc-stickyBar__navBar__item--active');
        if ($activeItem.length) {
            $activeItem[0].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        }
    }

    function updateActiveNavItem() {
        const navItems = $('.cc-stickyBar__navBar__item');
        let activeFound = false;

        navItems.each(function () {
            const $item = $(this);
            const sectionId = $item.data('section') || $item.attr('href')?.replace('#', '');

            if (sectionId) {
                const $section = $(`#${sectionId}`);
                if ($section.length) {
                    const sectionTop = $section.offset().top;
                    const sectionBottom = sectionTop + $section.outerHeight();
                    const currentScroll = $(window).scrollTop() + 100;

                    if (currentScroll >= sectionTop && currentScroll < sectionBottom && !activeFound) {
                        $('.cc-stickyBar__navBar__item').removeClass('cc-stickyBar__navBar__item--active');
                        $item.addClass('cc-stickyBar__navBar__item--active');
                        scrollToActiveItem();
                        activeFound = true;
                    }
                }
            }
        });
    }

    $(window).on('scroll', function () {
        if (window.isDesktop) {
            let currentScroll = $(window).scrollTop();

            if ($header.hasClass('cc-header--sticky')) {
                $stickyBar.addClass('cc-stickyBar__scrollDown');
            } else {
                $stickyBar.removeClass('cc-stickyBar__scrollDown');
            }

            if ($stickyBar.hasClass('cc-stickyBar__scrollDown')) {
                updateActiveNavItem();
            }

            lastScroll = currentScroll;
        }
        else {
            $stickyBar.removeClass('cc-stickyBar__scrollDown');
            return;
        }
    });

    $(document).on('click', '.cc-stickyBar__navBar__item', function () {
        $('.cc-stickyBar__navBar__item').removeClass('cc-stickyBar__navBar__item--active');
        $(this).addClass('cc-stickyBar__navBar__item--active');
        scrollToActiveItem();
    });
});